import React from "react";
import { LoadingComponent } from "../../../components/LoadingComponent";
import { Card } from "../Card";
import { WrapRow, AutoColumn, Label, Select } from "./styles";

interface Props {
  dados: Array<ComboData>;
  onChange: (selectedOption: any) => void;
  label: string;
  valorInicial?: string;
}

export interface ComboData{
  Value: string;
  Name: string;
}

export const ComboSimulador: React.FC<Props> = ({
  dados,
  onChange,
  label,
  valorInicial
}) => {

  function render(){
    const options = dados.map((dado: ComboData) => {
      return(
        <option selected={dado.Value === valorInicial} value={dado.Value}>
          {dado.Name}
        </option>
      );
    });

    if(options.length > 0){
      return(
        <WrapRow>
          <AutoColumn>
            <Label>
              <b>
                <label htmlFor={`${label}Componente`}>
                  {label}
                </label>
              </b>
            </Label>

            <Select name={`${label}Componente`} onChange={(e) => {
              onChange(e.target.selectedOptions[0].value)
            }}>
              {options}
            </Select>
          </AutoColumn>
        </WrapRow>
      );
    }

    return <LoadingComponent/>
  }

  return render();
}